import React from "react";

import { useIntl } from "react-intl";

import { Alert, Button } from "@mapmycustomers/ui";

import styles from "./TwoWaySyncAlert.module.scss";

const ALERT_LINK = "https://share.hsforms.com/1vG9XJwa3Sk2lWljCDHV50Q3is1h";

export const TwoWaySyncAlert: React.FC = () => {
  const intl = useIntl();

  return (
    <Alert
      action={
        <Button href={ALERT_LINK} target="_blank" type="link">
          {intl.formatMessage({
            id: "integrations.add.alert.action",
            defaultMessage: "Talk to an integration specialist",
            description: "Alert link on the Integration page",
          })}
        </Button>
      }
      className={styles.alert}
      message={intl.formatMessage({
        id: "integrations.add.alert.text",
        defaultMessage: "Looking for a two-way sync or a custom solution for your CRM?",
        description: "Alert text on the Integration page",
      })}
    />
  );
};

export default TwoWaySyncAlert;
